module.exports = __webpack_public_path__ + "media/images/new_home/discover-2-d34aa29ad16124e66d298e3e6c99075d.png";